import styled from 'styled-components';
import { css } from '../../styles/theme';
import { ImageTemplate } from './ImageTemplate';
import media from '../../styles/media';
import { rem } from 'polished';

export const ImageStyled = styled(ImageTemplate)`
    
`;
